import React from 'react';
import './EventCard.css';

const EventCard = ({ event, compact = false, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(event);
    } else if (event.eventUrl) {
      window.open(event.eventUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div
      className={`event-card ${compact ? 'event-card-compact' : ''}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      <div className="event-card-image-wrapper">
        <img
          src={event.imageUrl}
          alt={event.title}
          className="event-card-image"
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/400x200?text=Event';
          }}
        />
        <div className="event-card-overlay">
          <div className="event-card-date-badge">
            <i className="bi bi-calendar-event me-1"></i>
            {event.dateFormatted}
          </div>
          <h4 className="event-card-title">{event.title}</h4>
          {!compact && event.time && (
            <div className="event-card-time">
              <i className="bi bi-clock me-1"></i>
              {event.time}
            </div>
          )}
        </div>
      </div>
      {!compact && (
        <div className="event-card-content">
          <p className="event-card-description">
            {event.shortDescription}
          </p>
          <div className="event-card-footer">
            <span className="event-card-category">
              <i className="bi bi-tag me-1"></i>
              {event.category}
            </span>
            <span className="event-card-link">
              View Event <i className="bi bi-arrow-right"></i>
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventCard;
